module.exports = __webpack_public_path__ + "static/process mobile-23c3bd2455ec41add4a27a6e15f33496.svg";